module.exports = __webpack_public_path__ + "img/logo.96a50579.svg";